<nb-card class="bg-transparent">
  <nb-card-header class="pb-0">
    <div class="row">
      
      <div class="col-lg-8 col-12 text-lg-left">
        <h1 class="h3">{{'Downloads'}}</h1>
      </div>
      
      <div class="col-lg-4 col-12 text-lg-right">
        <div class="d-flex justify-content-end">
          <div class="me-3 filter-badge-wrapper">
            <button mat-stroked-button class="btn text-dark btn-sm" (click)="clearFilters()">
              <fa-icon [icon]="faBan" class="me-2"></fa-icon>Clear Filters
            </button>
            <span *ngIf="filterCount > 0" class="filter-badge">{{filterCount}}</span>
          </div>
        </div>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body [nbSpinner]="isloading">
    <div class="row">
      <div class="col-12" *ngIf="!isloading && downloadItems.length">
        <div class="grid-wrapper">
          <ejs-grid #grid [dataSource]="downloadItems" 
          [allowFiltering]="true" 
          [filterSettings]="filterSettings"
          [allowSorting]="true" 
          [allowSelection]="true"   
          [allowPaging]="true" 
          [allowExcelExport]="true"
          [pageSettings]="pageSettings"   
          [toolbar]="toolbar"
          width="auto"
          (toolbarClick)="toolbarClick($event)"
          height="600"
          (actionComplete)="onActionComplete($event)"
          (dataBound)="onGridDataBound()">

          <e-columns>
            <e-column field="name" headerText="Name" width="18%"></e-column>
            <e-column field="description" headerText="Description" width="25%"></e-column>
            <e-column field="fileName" headerText="FileName" width="15%"></e-column>
            <e-column field="fileType" headerText="FileType" width="18%"></e-column>
            <e-column field="fileSize" headerText="FileSize" width="15%"></e-column>
            <e-column field="dateOnly" headerText="Date" width="18%"></e-column>
            <e-column headerText="Actions"  [template]="downloadTemplate" width="15%"  textAlign="Center"></e-column>
          </e-columns>

          </ejs-grid>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
<ng-template #downloadTemplate let-data>
  <div class="d-flex justify-content-center">
    <button class="btn btn-sm btn-active-primary btn-icon-hover" (click)="downloadFile(data)">
      <fa-icon style="cursor: pointer;" [icon]="fadownload"></fa-icon>
    </button>
  </div>
</ng-template>